exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-32951d3b] {\n  padding: 0;\n}\n.page-header[data-v-32951d3b] .ant-page-header-heading-title {\n  font-size: 14px;\n}\n", ""]);

// exports
